import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  STORE_STATUS_INITIALIZED,
  STORE_USER,
  STORE_USER_FETCH_BACK_DOCUMENT_PHOTO,
} from 'constants/store'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'
import { ErrorStore } from '@types'

type DocumentPhotoState = {}

type State = GenericState<DocumentPhotoState>

export const initialState: State = {
  data: {},
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchBackDocumentPhoto = createAsyncThunk<
  DocumentPhotoState,
  Promise<any>,
  Payload
>(
  STORE_USER_FETCH_BACK_DOCUMENT_PHOTO,
  async (promise: Promise<any>, { rejectWithValue }) => {
    try {
      return await promise
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  DocumentPhotoState,
  any,
  Payload
>(fetchBackDocumentPhoto, initialState.data)

const userSlice = createGenericSlice({
  name: STORE_USER,
  initialState,
  reducers: {},
  extraReducers,
})

const { actions, reducer } = userSlice

const { clear } = actions

export { clear }

export default reducer
